import { useEffect, useState } from 'react';
import { cargarJson, jsonListo } from '../utils/arranque';

/**
 * JSON de un Lottie por URL, compartido: se descarga una sola vez para toda
 * la app, y si ya se precargó durante el splash está disponible desde el
 * primer render (sin un cuadro vacío antes). null mientras no hay URL o datos.
 *
 * Lo usan PromotionsBanner, el encabezado/promo de PromoSection y el título de
 * HomeSection, que antes hacían cada uno su propio fetch.
 */
export default function useLottieJson(url) {
  const [data, setData] = useState(() => jsonListo(url));

  useEffect(() => {
    if (!url) { setData(null); return; }
    let vivo = true;
    setData(jsonListo(url));
    cargarJson(url).then((d) => { if (vivo) setData(d); });
    return () => { vivo = false; };
  }, [url]);

  return data;
}
